export default function deterministicShuffle(array, seed = 0) {
  if (!array || array.length === 0) return array;

  const shuffled = [...array];

  const normalizedSeed = typeof seed === 'string'
    ? seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
    : Number(seed) || 0;

  let currentSeed = normalizedSeed;
  const random = () => {
    currentSeed = (currentSeed * 9301 + 49297) % 233280;
    return currentSeed / 233280;
  };

  // Algoritmo Fisher-Yates com gerador determinístico
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
}

export function combineSeed(...values) {
  if (values.length === 0) return 0;

  return values.reduce((acc, value, index) => {
    const numValue = typeof value === 'string'
      ? value.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0)
      : Number(value) || 0;

    if (index === 0) {
      return numValue * 1000;
    }
    return acc + numValue;
  }, 0);
}
